import React, { useContext, useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Button, CardActionArea } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useWallet } from "../../context/walletProvider";
import { Link } from "react-router-dom";

export default function FooterCard() {
  const wallet = useWallet();
  console.log(wallet);

  // useEffect(() => {
  //   getERC721Contract(wallet.web3);
  // }, []);
  return (
    <div className='mint-card-container'>
      <Card
        style={{
          display: "flex",
          backgroundColor: "#0E0E0E",
          marginTop: "30px",
        }}
      >
        <div style={{ width: "70%", paddingTop: "20px" }}>
          <CardContent style={{ padding: "0" }}>
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#CDCDCD",
                marginLeft: "230px",
              }}
              gutterBottom
              variant='h5'
              component='h2'
            >
              Mint a new NFT
            </Typography>
            <Typography
              style={{
                fontSize: "12px",
                color: "#CDCDCD",
                textAlign: "left",
                marginBottom: "10px",
                padding: "15px",
                marginLeft: "215px",
              }}
              variant='body2'
              color='textSecondary'
              component='p'
            >
              Mint a new NFT that you can fractionalize instantly
            </Typography>
          </CardContent>
        </div>
        <div style={{ paddingTop: "30px" }}>
          <Link to='/mint' style={{textDecoration:'none'}}>
          <Button
            style={{
              textAlign: "center",
              width: "100px",
              height: "40px",
              borderRadius: "20px",
              fontSize: "0.8em",
              fontWeight: "700",
              letterSpacing: "2px",
              boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
            }}
            variant='contained'
            size='large'
            onClick={()=>{
              console.log("trying to mint")
            }}
          >
            Mint
          </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
